import { supabase } from './supabase';
import type { PortalNotification } from '../types/portal';

// ============ Notifications (shared cross-app table, portal scope) ============

export async function fetchPortalNotifications(): Promise<PortalNotification[]> {
  const { data, error } = await supabase
    .from('notifications')
    .select('*')
    .eq('app', 'portal')
    .order('created_at', { ascending: false })
    .limit(50);
  if (error) throw error;
  return data;
}

export async function fetchUnreadPortalNotificationCount(): Promise<number> {
  const { count, error } = await supabase
    .from('notifications')
    .select('id', { count: 'exact', head: true })
    .eq('app', 'portal')
    .is('read_at', null);
  if (error) throw error;
  return count ?? 0;
}

export async function markPortalNotificationRead(id: string) {
  const { error } = await supabase
    .from('notifications')
    .update({ read_at: new Date().toISOString() })
    .eq('id', id);
  if (error) throw error;
}

export async function markAllPortalNotificationsRead() {
  const { error } = await supabase
    .from('notifications')
    .update({ read_at: new Date().toISOString() })
    .eq('app', 'portal')
    .is('read_at', null);
  if (error) throw error;
}
